import {fetchURL} from "./NamaCommon";
import * as ApplicationVersion from "../constants/ApplicationVersion";
import {getCustomGUISettings} from "../login/ClientCache";

export function getLatestRelease() {
    try {
        let latestRelease = fetchURL("https://nlm.namasoft.com/nlm/download.php?releasename=true&subr=" + getCustomGUISettings().tooltipsAndReportsAndRevise.subRelease);
        return latestRelease.substring(0, 4) + "-" + latestRelease.substring(4, 6) + "-" + latestRelease.substring(6, 8) + " " + latestRelease
            .substring(8, 10) + ":" + latestRelease.substring(10);
    } catch (e) {
        return "Could not connect";
    }
}

export function appVersion() {
    return ApplicationVersion.SERVER_VERSION + "." + ApplicationVersion.DATABASE_VERSION;
}

export function getBuildDate() {
    let buildDate = ApplicationVersion.BUILD_YEAR + "-" + lpad(ApplicationVersion.BUILD_MONTH) + "-" + lpad(ApplicationVersion.BUILD_DAY) + " " + lpad(
        ApplicationVersion.BUILD_HOUR) + ":" + lpad(ApplicationVersion.BUILD_MINUTE);
    if (getCustomGUISettings().tooltipsAndReportsAndRevise.subRelease)
        buildDate += buildDate + "-" + getCustomGUISettings().tooltipsAndReportsAndRevise.subRelease;
    return buildDate;
}

export function applicationVersion() {
    return ApplicationVersion.SERVER_VERSION + "." + ApplicationVersion.DATABASE_VERSION + "."
        + lpad(ApplicationVersion.BUILD_YEAR % 100, ApplicationVersion.BUILD_MONTH, ApplicationVersion.BUILD_DAY) + "."
        + lpad(ApplicationVersion.BUILD_HOUR, ApplicationVersion.BUILD_MINUTE);
}

function lpad(...parts) {
    let txt = "";
    for (let part of parts) {
        if (part > 1999)
            part = part - 2000;
        if (part < 10)
            txt += "0" + part;
        else
            txt += part;
    }
    return txt;
}